import React from 'react';

interface FieldProps {
  label: string;
  /** Span the full row of the grid. */
  wide?: boolean;
  /** Large value, for counts and totals. */
  big?: boolean;
  children?: React.ReactNode;
}

// Read-only label-over-value block used inside the order pop-up cards. Lay them out with
// a surrounding `.op-fields` grid.
const Field: React.FC<FieldProps> = ({ label, wide, big, children }) => (
  <div className={`op-field${wide ? ' op-field--wide' : ''}`}>
    <div className="op-field-label">{label}</div>
    <div className={`op-field-value${big ? ' op-field-value--big' : ''}`}>
      {children ?? '—'}
    </div>
  </div>
);

export default Field;
